import { createFileRoute } from '@tanstack/react-router';

import { ManageAccountsPage } from './ManageAccountsPage';

export const Route = createFileRoute('/_protected/_consumer/manage-accounts/')({
  component: ManageAccountsPage,
});
